<template>
  <b-container :style=guest.cardColor class="testimonial-card" fluid>
    <b-row class="flex-column-reverse flex-md-row">
      <b-col md="12">
        <b-row>
          <b-col style="padding-bottom: 10px">
            <img class="logo-image" alt="gravity logo" src="../assets/sendoso-logo.png" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="name text-white">{{ guest.name }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" >
            <img class="kris-image" alt="gravity logo" src="../assets/guests/kris.jpeg" />
          </b-col>
          <b-col md="8" >
            <p class="kris-title text-white"><b>Kris Rudeegraap</b> <br>CEO</p>
            <p></p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/_components/guest-card.sass
</style>

<script>
export default {
  props: ['guest'],
  name: 'GuestCard',
  methods: {
    truncate_name(text, length, clamp) {
      clamp = clamp || '...'
      var node = document.createElement('div')
      node.innerHTML = text
      var content = node.textContent
      return content.length > length
        ? content.slice(0, length) + clamp
        : content
    },
  },
}
</script>
